import Content from './Content.jsx';
import { Footer } from './components/Panels.jsx';

export default function App() {
  return (
    <div className="App">
      <main>
        <Content />
      </main>
      <Footer />
    </div>
  );
}
